import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import type { TimeDay } from "../api/types";
import { workerTimeDaysQuery } from "./useWorkerTimeDays";

/** Temps calculé par le serveur pour plusieurs workers sur une même plage de
 * jours : une requête par worker. Même clé que useWorkerTimeDays, donc même cache.
 * Pas de rechargement au retour sur l'onglet : une équipe entière, c'est une
 * requête par membre. */
export function useTeamTimeDays(
  workerUrls: string[],
  start: string,
  end: string,
): Map<string, Map<string, TimeDay>> {
  const results = useQueries({
    queries: workerUrls.map((w) => ({
      ...workerTimeDaysQuery(w, start, end),
      refetchOnWindowFocus: false,
    })),
  });

  const signal = results.map((r) => `${r.dataUpdatedAt}:${r.status}`).join(",");
  return useMemo(() => {
    const map = new Map<string, Map<string, TimeDay>>();
    workerUrls.forEach((w, i) => {
      map.set(
        w,
        new Map((results[i]?.data?.days ?? []).map((d) => [d.date, d])),
      );
    });
    return map;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signal, workerUrls.join("|")]);
}
